import axios from "axios";
import { Message } from "element-ui";
import store from "../store";
import { getCookie, Token } from "@/utils/cookie";
import router from "../router/index";
import Vue from 'vue'
// 后端联调接口
// 模拟接口-外网
const mockUrls = "http://wisdomorg.oicp.net:8083/mock/11";
// const url = process.env.NODE_ENV === 'development' ? mockUrls : process.env.LOCAL_BASE_API

const url = 'https://cqtally.co:8082' //  https 正式 外理 正式 《《《《
// const url = 'http://127.0.0.1:8099' //  本地测试 《《《《
// const url = 'http://192.168.1.107:8099' //  本地测试 《《《《

// const belongBranch = 'yl';  // 到货预报模块是否显示  '外理 显示 yl'
// Vue.prototype.$belongBranch = belongBranch


/***
*万州集装箱 打包说明
 地址为 http://172.21.1.5:8081
 1）
 文件地址：src>api>index.js  
 修改部分代码：const url = process.env.NODE_ENV === 'development' ? '/api' : 'http://172.21.1.5:8081'
 
 2）
 文件地址 config/index.js
 修改部分代码   target: 'http://172.21.1.5:8081',  //万州正式内网地址
 
 3）
 文件地址 /components/webSocket/mqtt.vue
 修改部分代码    const socket = ["172.21.1.5", "bytest", "123456"]; //万州正式内网地址
 
 4）
 登录界面修改
 文件地址 src>router>index
 修改部分代码：
 +
 
 
 {
     path: '/Login',
     name: 'login',
     // component: resolve => require(['../views/login/wlLogin.vue'], resolve),
     component: resolve => require(['../views/login/Login.vue'], resolve),
     meta: {
         title: "登录"
     }
 },
 
***/

Vue.prototype.$baseUrl = url


// 创建axios实例                
const service = axios.create({
    baseURL: url, // 开发环境跨域配置的地址
    timeout: 100000 // 请求超时时间
});


const loadingOver = () => {
    if (store.getters.loadingBtn) {
        store.commit("SET_LOADING_STATUS", false);
    }
};

// request拦截器
service.interceptors.request.use(
    config => {
        // 请求头统一配置
        //config.headers["Content-Type"] = "application/json;charset=UTF-8";
        config.headers["Accept"] = "application/json;charset=UTF-8";
        if (getCookie(Token)) {
            config.headers["Authorization"] = getCookie(Token); // 请求头携带Authorization为Token值
        }
        if (config.method === "put" || config.method === "post") {
            store.commit("SET_LOADING_STATUS", true);
        }
        return config;
    },
    error => {
        loadingOver();
        Promise.reject(error);
    }
);

// response拦截器
service.interceptors.response.use(
    response => {
        loadingOver();
        return response.data;
    },
    error => {
        loadingOver();
        //console.log(error.response)
        // let message = error.response.data.msg
        let message =
            error.response.data.msg || error.response.data.error || false;
        let msg = "";
        if (message) {
            if(message.indexOf("(系统找不到指定的文件。)") > 0){

            }else{
                msg =
                    message.indexOf("错误信息:") > 0
                        ? message.split("错误信息:")[1]
                        : message;
                Message({
                    message: `${msg}`,
                    showClose: true,
                    type: "error",
                    duration: 3 * 1000
                });
            }
        } else {
            msg = "服务器异常,请联系系统管理员";
            Message({
                message: `${msg}`,
                showClose: true,
                type: "error",
                duration: 3 * 1000
            });
        }
        if (error.response.status === 504 || error.response.status === 511||msg.indexOf('用户未登录')>0) {
            router.replace("/Login");
            return;
        }
        return Promise.reject(error);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/index.js